<div
  class="back-button-wrapper"
>
   <button
     class="navigation-button"
     [disabled]="disabled"
     [ngClass]="disabled ? 'disabled' : ''"
     appConfigSettingsButton
     (click)="goBack()"
  >
    {{'ApplicationPage.Back' | translate}}
  </button>
</div>
